import { subject } from '@casl/ability'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { createAppAbility } from './ability'
import { AbilityContext } from './AbilityContext'
import { AppAbilities, SessionInfoType, useFetchSessionInfoWithPermissionsQuery } from 'store/reducers/configs/sessionInfo.api'
import { useCaslModule } from '../../root/Routes/useCaslModule'
import { secureLocalStorageGet } from '../../app/helpers'

interface AbilityProviderProps {
  children?: React.ReactNode
}

export function AbilityProvider({ children }: AbilityProviderProps) {
  const role = secureLocalStorageGet('rol');
  
  const { refetch, data, isSuccess } = useFetchSessionInfoWithPermissionsQuery(undefined, {
    skip: !role
  })

  const moduleName = useCaslModule()

  // const ddd = isSuccess ? { moduleName: moduleName || '', user: { ...data, viewable: true } } : null
  const [abilityData, setAbility] = useState<AbilityContext['abilityData']>(null)

  useEffect(() => {
    if (!data) return
  
    if (moduleName) {
      refetch().then((res) => {
        const refreshedData = res.data
        if (refreshedData) {
          setAbility({ moduleName, user: { ...refreshedData, viewable: true } })
        }
      })
    } else {
      setAbility({ moduleName: '', user: { ...data, viewable: true } })
    }
  }, [moduleName, data])
  

  // useEffect(() => {
  //   if (moduleName) {
  //     (async () => {
  //       const data = await mutate().unwrap()
  //       setAbility({ moduleName, user: { ...data, viewable: true } })
  //     })()
  //   } else {
  //     setAbility(null)
  //   }
  // }, [moduleName])

  const ability = useMemo(() => {
    if (!abilityData) return createAppAbility([])

    const { moduleName: currentPage, user } = abilityData;

    const globalPermissions = user.permission.global || []
    const modulePermissionsWithouteRole =
      user.permission.modules[currentPage]?.['all'] || []
    const modulePermissions =
      user.permission.modules[currentPage]?.[user.role] || []

    const mergedPermissions = [
      ...globalPermissions,
      ...modulePermissionsWithouteRole,
      ...modulePermissions,
    ]

    return createAppAbility(mergedPermissions)
  }, [abilityData, isSuccess])

  const can = useCallback(
    (action: AppAbilities[0], subjectName: AppAbilities[1], fields: SessionInfoType = {}) => {
      if (!abilityData) return false
      const { user: { permission, ...userData } } = abilityData
      return ability.can(action, subject(subjectName, { ...userData, ...fields }))
    },
    [ability, abilityData]
  )

  const cannot = useCallback(
    (action: AppAbilities[0], subjectName: AppAbilities[1], fields: SessionInfoType = {}) => {
      if (!abilityData) return true
      const { user: { permission, ...userData } } = abilityData
      return ability.cannot(action, subject(subjectName, { ...userData, ...fields }))
    },
    [ability, abilityData]
  )

  const setAbilityData: AbilityContext['setAbilityData'] = (data) => {
    setAbility(data)
  }

  return (
    <AbilityContext.Provider value={{ abilityData, setAbilityData, ability: { can, cannot } }}>
      {children}
    </AbilityContext.Provider>
  )
}
